import { transformDateToLocalDateString } from "helpers";
import { ReactSVG } from "react-svg";
import { FleetVehicleFireExtinguisherRow } from "services/api/fleet/vehicles/fireextinguishers/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_VEHICLE_EDIT_FIRE_EXTINGUISHER_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div className="text-md font-medium text-slate-600">{row.name}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.serialnumber",
      field: "serialNumber",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.amount",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="text-sm text-slate-900 truncate">
              {row.price && `${row.price} €`}
            </div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.expirationdate",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div className="text-sm text-slate-900 truncate">
            {transformDateToLocalDateString(row.expirationDate)}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.weight",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="text-sm text-slate-900 truncate">
              {" "}
              {row.weight && `${row.weight} kw`}
            </div>
          </div>
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div onClick={(e) => handleDeleteClick(e, row.id)} className="flex justify-end items-center h-[30px]" >
            <ReactSVG
              src={"/media/icons/trash.svg"}
              className="w-4 h-4 stroke-[#bd0000]"
            />
          </div>
        );
      },
    },
  ];
